(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        /*
         * MEME SEUIL QUE LES FILTRES QU'IL PILOTE.
         *
         * `< 750` ignorait l'orientation, alors que la feuille des filtres et
         * `facets.js` traitent la tablette PORTRAIT comme du mobile. Sur iPad
         * portrait, un panneau de filtres ouvert se refermait donc au moindre clic
         * a cote, contrairement au telephone dans la meme presentation.
         */
        const closingOn = window.matchMedia(
          '(max-width: 749px), (max-width: 1023px) and (orientation: portrait)'
        ).matches
          ? 'mobile'
          : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });
})();
